export default __webpack_public_path__ + "static/one-aac88bfa74f529c8e0b7c37881cb5a57.jpg";